import React, { useEffect, useState } from "react";
import { roleList } from "../../../services/master";
import { academylist } from "../../../services/admin";
import { toast } from "react-toastify";
import Select from "react-select";
import { idcardbulk, studentuploadlogs } from "../../../services/student";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import { teacheruploadlogs } from "../../../services/teacher";

export default function Idcardbulkupload() {
  const [rlist, setRList] = useState([]);
  const [idtype, setIdType] = useState("");
  const [idate, setIdDate] = useState("");
  const [efile, setEFile] = useState("");

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [filterProduct, setFilterProduct] = useState([]);

  useEffect(() => {
    roleList().then((res) => {
      if (res.status === true) {
        setRList(res.data);
      }
    });

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                
              }
            }
           
          }
        }
      });
    }
  }, []);

  function listall(aid, atype) {
    setIdType(atype);
    setFilterProduct([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    temp.append("type", 2);
    if (atype == 4) {
      studentuploadlogs(temp).then((response) => {
        if (response.status === true) {
          setFilterProduct(response.data.details);
        }
      });
    } else {
      teacheruploadlogs(temp).then((response) => {
        if (response.status === true) {
          setFilterProduct(response.data.details);
        }
      });
    }

  }

  const [iderror, setIDError] = useState("");
  function idcardfile(event) {
    setIDError("");
    setEFile("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(xlsx|xls)$/i)) {
        setEFile(event.target.files[0]);
      } else {
        setIDError("Upload excel should be xls or xlsx format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setIDError("Upload excel size should be less than 5MB");
      }
    }
  }

  const [errmsg, setErrMsg] = useState("");
  function submitidcard(e) {
    e.preventDefault();
    setErrMsg("");
    if (idtype !== "") {
      if (idate !== "") {
        if (efile !== "") {
          setLoading(true)
          const temp = new FormData();
          if (localStorage.getItem("Role") === "1" && acaid !== "") {
            temp.append("academy_id", acaid.value);
          }
          temp.append("role", idtype);
          temp.append("issue_date", idate);
          temp.append("excel_name", efile);
          idcardbulk(temp).then((res) => {
            if (res.status === true) {
              setEFile("");
              setIdDate("");
              setAcaID("");
              setIdType("");
              setLoading(false)
              toast.success(res.message);
              listall(acaid, idtype);
            } else {
              setLoading(false)
              toast.error(res.message);
            }
          })
        } else {
          setErrMsg("Please Upload Excel");
        }
      } else {
        setErrMsg("Please Select Issued Date");
      }
    } else {
      setErrMsg("Please Select ID Type");
    }
  }
  function handleAcademy(e) {
    if (idtype !== "") {
      if (e !== null) {
        setAcaID(e);
        listall(e, idtype);
      } else {
        setAcaID("");
        listall("", idtype);
      }
    } else {
      toast.error("Please Select ID Card Type");
    }
  }
  const [loading, setLoading] = useState(false);
  const columnDefs = [
    {
      headerName: "Upload Excel",
      width: 170,
      field: "excel_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              className="excelfailed text-success"
              href={params.data.path + params.value}
              download={params.data.path + params.value}
              target="_blank"
            >
              Click to Download
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Failed Excel",
      width: 150,
      field: "mandatory_excel",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return (
            <div className="text-center">
              <a
                className="excelfailed text-danger"
                href={params.data.path + params.value}
                download={params.data.path + params.value}
                target="_blank"
              >
                Click to Download
              </a>
            </div>
          );
        }
      },
    },
    {
      headerName: "Uploaded on",
      width: 150,
      field: "created_at",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy hh:mm:ss A");
        }
      },
    },
    {
      headerName: "Uploaded by",
      width: 150,
      field: "user",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">ID Card Bulkupload</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>ID Card</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            ID Card Bulkupload
          </li>
        </ol>
      </div>

      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading &&
        <div className="content-body">
          <div className="container-fluid">
            <div className="card">
              <div className="card-header">
                <h2 className="main-content-title tx-24 mg-b-5">ID Card Bulkupload</h2>

              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12 res-right">
                    <a className="btn btn-secondary" href={require("../../../assets/images/IDCard_BulkUpload.xlsx")} download>
                      Download Sample Excel
                    </a>
                  </div>
                  <div className="col-xl-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        ID Card Type<span className="text-danger"> *</span>
                      </label>
                      <select
                        className="default-select  form-control wide"
                        onChange={(e) => listall(acaid, e.target.value)}
                        value={idtype}
                      >
                        <option value="" disabled>
                          Select ID Card Type
                        </option>
                        {rlist.map((item) => (
                          <>
                            {item.id > 2 && (
                              <option value={item.id} key={item.id}>
                                {item.name}
                              </option>
                            )}
                          </>
                        ))}
                      </select>
                    </div>
                  </div>
                  {localStorage.getItem("Role") === "1" && (
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Select Academy <span className="text-danger"> *</span>
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Academy"
                          value={acaid}
                          options={aclist}
                          onChange={handleAcademy}
                          isSearchable={true}
                          isClearable
                          hidden
                        />
                      </div>
                    </div>
                  )}

                  <div className="col-xl-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Issued Date
                        <span className="text-danger"> *</span>
                      </label>
                      <div className="input-group">
                        <input
                          className="form-control"
                          type="date"
                          onChange={(e) => setIdDate(e.target.value)}
                          value={idate}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Upload Excel<span className="text-danger"> *</span>
                      </label>
                      <input
                        type="file"
                        className="form-control buttion-file"
                        accept=".xlsx, .xls"
                        onChange={idcardfile}
                      />
                    </div>
                  </div>
                </div>
                {errmsg !== "" && <span className="text-danger">{errmsg}</span>}
              </div>
              <div className="res-right mt-2 me-4 mb-2">
                <button className="btn btn-success" onClick={submitidcard}>
                  Submit
                </button>
              </div>
            </div>

            <div className="card custom-card mg-b-20">
              <div className="card-body">
                <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    Upload Preview
                  </h2>
                </div>
                <div className="ag-theme-alpine ag-style mt-2">
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      }

    </div>
  );
}
